import { SupportedLanguage } from '@foundation/localization';

import { execGet } from '@/services/utils/RequestUtils';

import { ECommerceConnectUrlApiResponse } from '../schemas';

export async function getEcommerceConnectRedirectUrl(
  paymentIntentId: string,
  accessToken: string,
  locale = SupportedLanguage.English,
  telemetryConsent = false,
): Promise<string> {
  const response = await execGet<ECommerceConnectUrlApiResponse>(
    `paymentintent/${paymentIntentId}/ecommerceconnect/url?tc=${telemetryConsent}&locale=${locale}`,
    accessToken,
  );

  return response.redirectUrl;
}
